import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Button } from "src/components/base/button";
import { Dialog, DialogActions, DialogBody, DialogTitle } from "src/components/base/dialog";
import { Input } from "src/components/base/input";

/**
 * The properties for {@link Login}
 */
export type LoginProps = {
    /** The function that should be executed on a successful login */
    onLogin: () => void;
};

const MOCK_PASSWORD = "a3a62181236bbb0f";

/**
 * The login dialog — shown as an overlay when the user is not authenticated.
 */
export default function Login(props: LoginProps) {
    const [t] = useTranslation("login");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(false);

    function handleSubmit() {
        if (password === MOCK_PASSWORD) {
            props.onLogin();
        } else {
            setError(true);
        }
    }

    return (
        <Dialog open={true} onClose={() => {}} size="sm">
            <div className="mb-4 flex items-center gap-3">
                <img src="/logo.svg" alt="Trufflepig" className="h-8 w-8 opacity-90" />
                <DialogTitle className="!mt-0">Trufflepig Forensics</DialogTitle>
            </div>
            <DialogBody>
                <Input
                    type="password"
                    placeholder={t("dialog.placeholder")}
                    value={password}
                    autoFocus
                    onChange={(e) => {
                        setPassword(e.target.value);
                        setError(false);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") handleSubmit();
                    }}
                    data-invalid={error || undefined}
                />
                {error && <p className="mt-2 text-sm text-red-500">{t("dialog.error")}</p>}
            </DialogBody>
            <DialogActions>
                <Button color="blue" onClick={handleSubmit} className="w-full">
                    {t("button.sign-in-sso")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
